/*
  update-raffle-component.ts
  Golfhubber
  Created by Chetan Baghel on 28/09/2021.
  Copyright © 2021 Golfhubber Ltd. All rights reserved.
*/
import { Component, OnInit } from '@angular/core';
import { Attachment } from 'app/models/attachment';
import { OAuthService } from 'app/services/o-auth';
import { DatePipe } from "@angular/common";
import { AngularFireDatabase } from 'angularfire2/database';
import { ActivatedRoute, Router } from '@angular/router';
import { AngularFireAuth } from 'angularfire2/auth';
import { FirebaseApp } from 'angularfire2';
import * as moment from "moment";
import { ApiService } from 'app/services/api';

@Component({
  selector: 'app-update-raffle',
  templateUrl: './update-raffle.component.html',
  styleUrls: ['./update-raffle.component.scss']
})
export class UpdateRaffleComponent implements OnInit {

  constructor(
    private oAuthService: OAuthService,
    private datePipe: DatePipe,
    private route: ActivatedRoute,
    private router: Router,
    private firebase: FirebaseApp,
    private fireAuth: AngularFireAuth,
    private fireDatabase: AngularFireDatabase,
    private apiService: ApiService,
  ) { }

  public raffle: any;
  public raffleId: any;
  public minFrom = new Date();
  public user: any;
  public minEndDate = new Date();
  public minDrawDate = new Date();
  public isValidateMaxTicketPerUser: Boolean = true;
  public imageLoader: boolean = false;
  private attachment: Attachment;
  private attachmentExt: string;
  
  objectKeys = Object.keys;

  async ngOnInit() {

    this.user = this.oAuthService.getClub();
    this.raffleId = this.route.snapshot.paramMap.get("id");
    await this.getRaffle();

  }

  async getRaffle() {
    this.imageLoader = true;
    this.raffle = await this.apiService.object(`raffles/${this.raffleId}`);
    this.raffle.startDate = new Date(this.raffle.startDate);
    this.raffle.endDate = new Date(this.raffle.endDate);
    this.minDrawDate = this.raffle.endDate;
    this.minEndDate = this.raffle.startDate;
    this.raffle.drawDate = new Date(this.raffle.drawDate);
    this.imageLoader = false;
  }

   changeAttachment(attachment: Attachment): void {
    if (attachment) {
      this.attachment = attachment;
      this.attachmentExt = attachment.file.name.split(".").pop();

    } else {
      this.attachment = undefined;
      this.attachmentExt = "";
    }
   }
  
  remove() {
    this.attachment = undefined;
    this.attachmentExt = "";
    this.raffle.image = undefined;
  }
  
  validateMaxTicketPerUser() {
    let maxTicketPerUser = (isNaN(parseInt(this.raffle.maxTicketPerUser)) ? 0 :parseInt(this.raffle.maxTicketPerUser));
    let stock = (isNaN(parseInt(this.raffle.stock)) ? 0 : parseInt(this.raffle.stock));
    if(maxTicketPerUser < stock)
    this.isValidateMaxTicketPerUser = true;
    else this.isValidateMaxTicketPerUser = false;

    console.log("(this.isValidateMaxTicketPerUse: ", maxTicketPerUser < stock, "maxTicketPerUser: ", maxTicketPerUser, "stock: ", stock);
    
  }

  private uploadFile(): Promise<any> {
    var newImage = new Promise((resolve, reject) => {
      if (this.attachment) {
        const filename = `${moment().unix()}.${this.attachmentExt}`;
        this.firebase
          .storage()
          .ref(`/raffles/${this.fireAuth.auth.currentUser.uid}`)
          .child(filename)
          .put(this.attachment.file)
          .then((result) => resolve(result))
          .catch((error) => reject(error));
      } else {
        return resolve("");
      }
    });
    return Promise.all([newImage]);
  }

   async onChangeStartDate() {
    this.minEndDate = new Date(this.raffle.startDate);
    
    this.minEndDate.setDate(this.minEndDate.getDate() + 1);

    this.raffle.endDate = "";
    this.raffle.drawDate = "";
  }

  onChangeEndDate() {
    this.minDrawDate = new Date(this.raffle.endDate);
    this.raffle.drawDate = "";

  }

  submit() {
    if (!this.attachment && !this.raffle.image)
    {
      alert("Please add Image");
      return
    }
    this.raffle.startDate = this.datePipe.transform(this.raffle.startDate, "yyyy-MM-dd");
    this.raffle.endDate = this.datePipe.transform(this.raffle.endDate, "yyyy-MM-dd");
    this.raffle.drawDate = this.datePipe.transform(this.raffle.drawDate, "yyyy-MM-dd");

    let today_date = moment().format("YYYY-MM-DD");

    if(this.raffle.status == 3 && this.raffle.startDate <= today_date && this.raffle.endDate >= today_date) {
      this.raffle.status = 1;
    }

    this.imageLoader = true;
    this.uploadFile()
      .then((fileResult) => {
        if(fileResult[0] && fileResult[0].downloadURL) {
          this.raffle.image = fileResult[0].downloadURL;
        }
        this.fireDatabase.database
          .ref(`/raffles/${this.raffleId}`)
          .update(this.raffle)
          .then((postResult) => {
            this.fireDatabase.database
              .ref(`/index/raffles/${this.raffleId}`)
              .set({userId: this.raffle.userId, uid: this.raffle.uid})
              .then(() => {
                this.router.navigate(["/components/raffle"]);
              })
              .catch((error) => {
                this.error(error);
              });
          })
          .catch((error) => {
            this.error(error);
          });
      })
      .catch((error) => {
        this.error(error);
      });
  }

  private error(error): void {
    console.error(error);
    this.imageLoader = false;
    alert("Sorry, something went wrong!");
  }
}
